import React from "react";
import "./pagination.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";


const Paginations = ({ count, page, handlePageChange }) => {
  return (
    <div>
      <div className="pagination">
        <Stack spacing={2}>
          <Pagination
            count={count}
            className="pagination"
            page={page}
            size="medium"
            defaultPage={1}
            color="primary"
            onChange={handlePageChange}
          />
        </Stack>
      </div>
    </div>
  );
};

export default Paginations;
